module.exports = __webpack_public_path__ + "static/img/flaga_pl.4a4b88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flaga_pl.png
// module id = Csl9
// module chunks = 0